import Container from "react-bootstrap/Container";

import React, { useState, useRef } from "react";
import Nav from "react-bootstrap/Nav";
import "./Navbars.css";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link } from "react-router-dom";
//import logoGeega from "../../assets/logoGeega.jpeg";
import emailjs from "emailjs-com";
import { Modal, Button, Form } from "react-bootstrap";
import gaga from "../../assets/gaga.jpg";
import CareerModal from "../CareerModal/CareerModal";
import ContactModal from "../ContactModal/ContactModal";
function Navbars(props) {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showCareersModal, setShowCareersModal] = useState(false);

  const handleContactModalOpen = () => setShowContactModal(true);
  const handleContactModalClose = () => setShowContactModal(false);
  const handleCareersModalOpen = () => setShowCareersModal(true);
  const handleCareersModalClose = () => setShowCareersModal(false);

  const [showCareerModal, setShowCareerModal] = useState(false);

  const handleCareerModalShow = () => setShowCareerModal(true);
  const handleCareerModalClose = () => setShowCareerModal(false);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID')
      .then((result) => {
          alert("Message Sent, We will get back to you shortly", result.text);
      }, (error) => {
          alert("An error occurred, Please try again", error.text);
      });
    e.target.reset();
  };


  return (
    <>
      {["lg"].map((expand) => (
        <Navbar key={expand} expand={expand} className="mb-3 checkB">
          <Container fluid>
            <Navbar.Brand href="/">
              <img src={gaga} alt="Limited" width="180px" height="auto" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="start"
              className="bNav"
              style={{ backgroundColor: "#fff" }}
            >
              <Offcanvas.Header className="mNav" closeButton>
                <Offcanvas.Title
                  id={`offcanvasNavbarLabel-expand-${expand}`}
                  style={{ color: "white" }}
                >
                  Geega Resources
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-center flex-grow-1 pe-3 ">
                  <Nav.Link href="">
                    <Link
                      //style={{ textDecoration: "none", color: "#373738" }}
                      to="/"
                      className="NavItem"
                    >
                      Home
                    </Link>
                  </Nav.Link>
                  {/* <Nav.Link href="#S">SERVICES</Nav.Link> */}

                  <NavDropdown
                    title="About Us"
                    id="about-dropdown"
                    className="NavItem"
                  >
                    <NavDropdown.Item as={Link} to="/about">
                      Geega Resources
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item as={Link} to="/board">
                      Board of Directors
                    </NavDropdown.Item>
                  </NavDropdown>

                  {/* <Nav.Link href="#W">About Us</Nav.Link> */}
                  <Nav.Link href="">
                    <Link
                      //style={{ textDecoration: "none", color: "#373738" }}
                      to="/service"
                      className="NavItem"
                    >
                      Production Areas
                    </Link>
                  </Nav.Link>

                  {/* <NavDropdown
                    title="Production Areas"
                    //id={`offcanvasNavbarDropdown-expand-${expand}`}
                    id="services-dropdown"
                  >
                    <NavDropdown.Item href="">
                      {" "}
                      <Link
                        style={{ textDecoration: "none", color: "#373738" }}
                        to="/service"
                      >
                        Crop Production
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="">
                      <Link
                        style={{ textDecoration: "none", color: "#373738" }}
                        to="/service"
                      >
                        Animal Husbandry and Fish Farming
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="">
                      <Link
                        style={{ textDecoration: "none", color: "#373738" }}
                        to="/service"
                      >
                        Clothe Productions
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="">
                      <Link
                        style={{ textDecoration: "none", color: "#373738" }}
                        to="/service"
                      >
                        Shoe Production
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="">
                      <Link
                        style={{ textDecoration: "none", color: "#373738" }}
                        to="/service"
                      >
                        Production of Wooden Furniture
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="">
                      <Link
                        style={{ textDecoration: "none", color: "#373738" }}
                        to="/service"
                      >
                        Baking Bread and Similar Products
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="">
                      <Link
                        style={{ textDecoration: "none", color: "#373738" }}
                        to="/service"
                      >
                        Table Water Production
                      </Link>
                    </NavDropdown.Item>
                  </NavDropdown> */}

                  <Nav.Link href="">
                    <Link
                      // style={{ textDecoration: "none", color: "#373738" }}
                     // to="/ComingSoon"
                      className="NavItem"
                      onClick={handleCareerModalShow}
                    >
                      Careers
                    </Link>
                  </Nav.Link>
                  <Nav.Link href="">
                    <Link
                      //style={{ textDecoration: "none", color: "#373738" }}
                      to="/gallery"
                      className="NavItem"
                    >
                      Gallery
                    </Link>
                  </Nav.Link>
                  <Nav.Link href="">
                    <Link
                      //style={{ textDecoration: "none", color: "#373738" }}
                      //to="/ComingSoon"
                      className="NavItem"
                      onClick={handleContactModalOpen}
                    >
                      Contact Us
                    </Link>
                  </Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}


{/* Contact Us Modal */}
<ContactModal show={showContactModal} handleClose={handleContactModalClose} />

      {/* Careers Modal */}
      
      <CareerModal show={showCareerModal} handleClose={handleCareerModalClose} />

    </>
  );
}

export default Navbars;
